import { UseFormRegister, FieldErrors } from "react-hook-form";
import styled from "styled-components";
import {
  ErrorMessage,
  FormGroup,
  Label,
} from "../../../components/common/Form";
import type { CourseType } from "../../../types/course";
import { InfoBox, InfoLabel, InfoValue } from "./ReadOnlyInfo";

const RadioGroup = styled.div`
  display: flex;
  gap: 16px;
`;

const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 16px;

  input[type="radio"] {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
`;

type FormInputs = {
  type: CourseType;
  level: string;
  companion_id: string;
};

type Props = {
  isReadOnly: boolean;
  currentType?: CourseType;
  register: UseFormRegister<FormInputs>;
  errors: FieldErrors<FormInputs>;
};

export const CourseTypeField = ({
  isReadOnly,
  currentType,
  register,
  errors,
}: Props) => {
  if (isReadOnly && currentType) {
    return (
      <InfoBox>
        <InfoLabel>Tipo di corso</InfoLabel>
        <InfoValue>{currentType === "ski" ? "SCI" : "SNOWBOARD"}</InfoValue>
      </InfoBox>
    );
  }

  return (
    <FormGroup>
      <Label>Tipo di corso</Label>
      <RadioGroup>
        <RadioLabel>
          <input
            type="radio"
            value="ski"
            {...register("type", {
              required: "Seleziona il tipo di corso",
            })}
          />
          SCI
        </RadioLabel>
        <RadioLabel>
          <input
            type="radio"
            value="snow"
            {...register("type", {
              required: "Seleziona il tipo di corso",
            })}
          />
          SNOWBOARD
        </RadioLabel>
      </RadioGroup>
      {errors.type && <ErrorMessage>{errors.type.message}</ErrorMessage>}
    </FormGroup>
  );
};
